import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import classnames from 'classnames';
import autosize from 'autosize';
import PropTypes from 'prop-types';

var Textarea = /*#__PURE__*/function (_Component) {
  _inherits(Textarea, _Component);

  var _super = _createSuper(Textarea);

  function Textarea() {
    _classCallCheck(this, Textarea);

    return _super.apply(this, arguments);
  }

  _createClass(Textarea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoGrow) {
        autosize(this._textarea);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          error = _this$props.error,
          classNames = _this$props.classNames,
          id = _this$props.id,
          autoGrow = _this$props.autoGrow,
          inverse = _this$props.inverse,
          disabled = _this$props.disabled,
          otherProps = _objectWithoutProperties(_this$props, ["error", "classNames", "id", "autoGrow", "inverse", "disabled"]);

      var cssClass = classnames({
        'tds-textarea tds-textarea--no-height': true,
        'tds-textarea--has-error': error,
        'tds-textarea--inverse': inverse,
        'tds-textarea--disabled': disabled
      }, classNames);
      return /*#__PURE__*/React.createElement("textarea", _extends({
        id: id,
        ref: function ref(textarea) {
          _this._textarea = textarea;
        },
        className: cssClass,
        disabled: disabled
      }, otherProps));
    }
  }]);

  return Textarea;
}(Component);

Textarea.displayName = "Textarea";
// Props used in TextAreaGroup
Textarea.propTypes = {
  id: PropTypes.string.isRequired,
  classNames: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  error: PropTypes.bool,
  autoGrow: PropTypes.bool,
  inverse: PropTypes.bool,
  disabled: PropTypes.bool
};
Textarea.defaultProps = {
  autoGrow: false,
  inverse: false,
  disabled: false,
  error: false,
  classNames: []
};
export default Textarea;